<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h3 mat-dialog-title>Dynamic Color Settings</h3>
<p class="fieldName">Field: {{ name }}</p>

<div mat-dialog-content #target>
  <ng-container *ngIf="loading">
    <div class="loading-spinner">
      <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
    </div>
  </ng-container>
  <div [hidden]="loading">
    <mat-table
      #table
      [dataSource]="dataSource"
      style="width: 100%"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      cdkDropListData="dataSource"
      [cdkDropListDisabled]="dragDisabled"
    >
      <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
        <th
          mat-header-cell
          *matHeaderCellDef
          style="white-space: nowrap;width:{{ col.width }}"
          [width]="col.width"
        >
          {{ col.label
          }}<span class="requiredAsterix" *ngIf="col.required">*</span>
        </th>
        <ng-container *matCellDef="let element; let i = index">
          <td mat-cell class="tablehchart">
            <div [ngSwitch]="col.type">
              <ng-container *ngSwitchCase="'position'">
                <span class="position">{{ i + 1 }}. </span>
              </ng-container>
              <ng-container *ngSwitchCase="'value'">
                <fa-icon
                  [icon]="faGripDotsVertical"
                  class="dragCursor"
                  (mousedown)="dragDisabled = false"
                  cdkDragHandle
                ></fa-icon>
                <input
                  matInput
                  [(ngModel)]="element[col.key]"
                  [hidden]="true"
                />
              </ng-container>
              <ng-container *ngSwitchCase="'form'">
                <input
                  matInput
                  [(ngModel)]="element[col.key]"
                  [hidden]="true"
                />
                <app-configure-threshold-items
                  [fieldConfig]="fieldConfig"
                  [elementId]="i"
                  [fieldData]="element['value']"
                  (exportFormEvent)="rowFormContents($event)"
                ></app-configure-threshold-items>
              </ng-container>

              <ng-container *ngSwitchCase="'color'">
                <span
                  class="color"
                  style="
                    display: inline-block;
                    margin-left: 20px;
                    padding-bottom: 20px;
                  "
                >
                  <ngx-colors
                    ngx-colors-trigger
                    [(ngModel)]="element[col.key]"
                    [hideTextInput]="true"
                    [hideColorPicker]="true"
                  ></ngx-colors>
                </span>
              </ng-container>

              <mat-form-field
                appearance="fill"
                class="form-input"
                *ngSwitchDefault
                style="
                  margin-bottom: 0;
                  margin-left: 5px;
                  width: 98%;
                  background-color: red;
                "
              >
                <input
                  matInput
                  [(ngModel)]="element[col.key]"
                  placeholder="{{ element[col.placeholder] }}"
                />
              </mat-form-field>

              <div class="btn-edit" *ngSwitchCase="'isEdit'">
                <fa-icon
                  [icon]="faTrash"
                  style="
                    cursor: pointer;
                    padding-bottom: 15px;
                    display: inline-block;
                  "
                  (click)="removeRow(element.id)"
                ></fa-icon>
              </div>
            </div>
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index"
        cdkDrag
        [cdkDragData]="row"
      >
        >
      </tr>
    </mat-table>
  </div>
  <br />
  <div class="error" *ngIf="error">
    Two or more thresholds have the same value configuration
  </div>
</div>
<div mat-dialog-actions align="end">
  <button
    class="button-add-row button_small"
    mat-button
    (click)="addRow()"
    [disabled]="validateForm()"
  >
    Add Setting
  </button>
  <span class="spacer" style="flex: 1 1 auto"></span>
  <button mat-button mat-dialog-close class="button_small cancel" *ngIf="!auto">
    cancel
  </button>
  <button
    *ngIf="auto"
    mat-button
    class="button_small cancel"
    (click)="onCancelClick()"
    style="width: 130px"
  >
    cancel & remove
  </button>

  <button
    *ngIf="loading"
    mat-button
    class="button_small"
    (click)="onConfirmClick()"
    [disabled]="loading"
  >
    apply
  </button>
  <button
    *ngIf="!loading"
    mat-button
    class="button_small"
    (click)="onConfirmClick()"
    [disabled]="validateForm()"
  >
    apply
  </button>
</div>
